import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamPasswordResetList = () => {
    return (
        <Box sx={{ p: 3, border: '1px dashed #ccc', borderRadius: '8px', textAlign: 'center' }}>
            <Typography variant="body1" sx={{ color: '#666' }}>
                Configure password reset policies for your team.
            </Typography>
        </Box>
    );
};

export default TeamPasswordResetList;

